import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "flex sm12" }
const _hoisted_3 = { class: "row py-3 ml-2" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 0,
  class: "flex sm4 md3"
}
const _hoisted_6 = { class: "mdo-select" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "account" }, "Conta", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 1,
  class: "flex sm4 md3"
}
const _hoisted_10 = { class: "mdo-select" }
const _hoisted_11 = { for: "agent" }
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 2,
  class: "flex sm4 md3"
}
const _hoisted_14 = { class: "mdo-select" }
const _hoisted_15 = { for: "campaign" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "flex sm4 md3" }
const _hoisted_18 = { class: "mdo-select" }
const _hoisted_19 = { for: "status" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "flex sm4 md3" }
const _hoisted_22 = { class: "flex sm4 md3" }
const _hoisted_23 = { class: "flex sm4 md3" }
const _hoisted_24 = { class: "flex xs6" }

import {
  Account,
  Agent,
  Book,
  BookConditionAndInput,
  BookSearchInput,
  BookStatusEnum,
  Campaign,
  ConditionIntInput,
  PermissionEnum
} from "@/codes/gen/types";
import { BookService } from "@/codes/services/BookService";
import { ReactiveData } from "@/codes/types/MDOTypes";
import Swal from "sweetalert2";
import { onMounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { DEFAULT_ITEMS_PER_PAGE, ROUTE_NAMES, VUEX_ACTIONS } from '@/codes/util/constants';
import { calculatePageCount, hasPermission } from '@/codes/util/functions';
import { AccountService } from "@/codes/services/AccountService";
import { AgentService } from "@/codes/services/AgentService";
import { CampaignService } from "@/codes/services/CampaignService";
import store from "@/store";
import { config } from "@/config";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loadingBooks = ref(false);
let page = 1;
const pageCount = ref(1);
const itemsPerPage = ref(DEFAULT_ITEMS_PER_PAGE);
const books = reactive<ReactiveData<Book[]>>({ data: [] as Book[] });
const accounts = reactive<ReactiveData<Account[]>>({ data: [] as Account[] });
const agents = reactive<ReactiveData<Agent[]>>({ data: [] as Agent[] });
const campaigns = reactive<ReactiveData<Campaign[]>>({ data: [] as Campaign[] });
const filter = reactive<ReactiveData<BookSearchInput>>({
  data: {
    and: {
      sequential: {} as ConditionIntInput
    } as BookConditionAndInput 
  } as BookSearchInput
});
const hasAccountPermission = ref(hasPermission(PermissionEnum.AccountRead));
const hasAgentPermission = ref(hasPermission(PermissionEnum.AgentRead));
const hasCampaignPermission = ref(hasPermission(PermissionEnum.CampaignRead));
const linkDownloadCsv = ref("");
const linkDownloadPDF = ref("");
const linkDownloadPDFLayout = ref("");

let pageLoaded = 0;

const i18n = useI18n();

const bookStatus = reactive({ data: [] as any });
for (const a of Object.values(BookStatusEnum)) {
  const t = i18n.t(`enums.${a}`);
  bookStatus.data.push({ text: t, value: a });
}

const headers = reactive({ data: [
  { key: 'sequential', label: i18n.t('book.sequential'), width: 150 },
  { key: 'status', label: i18n.t('book.status'), width: 150 },
  { key: 'qtScannedSheets', label: i18n.t('book.scanned'), width: 50 },
  { key: 'qtExamDone', label: i18n.t('book.examDone'), width: 50 },
  { key: 'qtAbandoned', label: i18n.t('book.examAbandoned'), width: 50 },
]});

const loadAccounts = async function() {
  accounts.data = [];

  if (!hasAccountPermission.value)
    {return;}

  const accountService = new AccountService();
  const result = await accountService.getAll({});
  if (result) {
    accounts.data = result.edges;
  }
}

const loadAgents = async function() {
  agents.data = [];

  if (!hasAgentPermission.value)
    {return;}
    
  const agentService = new AgentService();
  const result = await agentService.getAll({});
  if (result) {
    agents.data = result.edges;
  }
}

const loadCampaigns = async function() {
  campaigns.data = [];

  if (!hasCampaignPermission.value)
    {return;}
    
  const campaignService = new CampaignService();
  const result = await campaignService.getAll({});
  if (result) {
    campaigns.data = result.edges;
  }
}

const loadBooks = async function() {
  books.data = [];
  loadingBooks.value = true;
  const service = new BookService();
  const booksEdge = await service.getAll({ page: page, perPage: itemsPerPage.value });
  if (booksEdge) {
    pageCount.value = calculatePageCount(itemsPerPage.value, booksEdge.pagination?.total ?? 1);
    books.data = booksEdge.edges;
    pageLoaded = page;
  }
  loadingBooks.value = false;
}

store.subscribeAction({
  after: (action) => {
    if (action.type === VUEX_ACTIONS.setUserInfo) {
      hasAccountPermission.value = hasPermission(PermissionEnum.AccountRead);
      hasAgentPermission.value = hasPermission(PermissionEnum.AgentRead);
      hasCampaignPermission.value = hasPermission(PermissionEnum.CampaignRead);

      loadAccounts();
      loadAgents();
      loadCampaigns();
    }
  }
});

const onPageChanged = function(newPage: number) {
  page = newPage;
  loadBooks();
}

onMounted(() => {
  loadBooks();

  loadAccounts();
  loadAgents();
  loadCampaigns();
});

const filterBooks = async function(filter: BookSearchInput) {
  books.data = [];
  loadingBooks.value = true;
  const service = new BookService();
  const booksEdge = await service.getAll(filter);
  if (booksEdge) {
    pageCount.value = calculatePageCount(itemsPerPage.value, booksEdge.pagination?.total ?? 1);
    books.data = booksEdge.edges;
    pageLoaded = page;
    linkDownloadCsv.value = booksEdge.linkDownloadCSV;
    linkDownloadPDF.value = booksEdge.linkDownloadPDF;
    linkDownloadPDFLayout.value = booksEdge.linkDownloadPDFLayout;
  }
  loadingBooks.value = false;
}

const createBooks = async function(quantity: number) {
  const service = new BookService();
  const createResult = await service.create(quantity);
  if (createResult?.quantity === quantity) {
    filterBooks({ and: { lote: createResult.lote }});
    Swal.close();
  } else {
    Swal.fire({
      title: i18n.t('error.title'),
      text: createResult?.message
    })
  }
}

const cleanFilter = function() {
  filter.data = {
    and: {
      sequential: {} as ConditionIntInput
    } as BookConditionAndInput 
  } as BookSearchInput;

  loadBooks();
}

const executeFilter = function() {
  let hasFilter = false;
  const f: BookSearchInput = {
    and: {} as BookConditionAndInput
  };

  if (!f.and) {
    return;
  }

  if (filter.data.and?.account) {
    hasFilter = true;
    f.and.account = filter.data.and.account;
  }
  if (filter.data.and?.agent) {
    hasFilter = true;
    f.and.agent = filter.data.and.agent;
  }
  if (filter.data.and?.campaign) {
    hasFilter = true;
    f.and.campaign = filter.data.and.campaign;
  }
  if (filter.data.and?.lote) {
    hasFilter = true;
    f.and.lote = filter.data.and.lote;
  }
  if (filter.data.and?.sequential && (filter.data.and?.sequential.gte || filter.data.and?.sequential.lte)) {
    f.and.sequential = {} as ConditionIntInput;
    if (filter.data.and?.sequential.gte) {
      hasFilter = true;
      f.and.sequential.gte = parseInt(filter.data.and.sequential.gte.toString());
    }
    if (filter.data.and?.sequential.lte) {
      hasFilter = true;
      f.and.sequential.lte = parseInt(filter.data.and.sequential.lte.toString());
    }
  }
  if (filter.data.and?.status) {
    hasFilter = true;
    f.and.status = filter.data.and.status;
  }

  if (hasFilter) {
    filterBooks(f);
  } else {
    Swal.fire({
      title: i18n.t("form.noFilterTitle"),
      text: i18n.t("form.noFilterText")
    })
  }
}

const openScanner = function() {
  const w = window.open(config.urlScanner, "_blank");
  w?.focus();
}

const downloadCsv = function() {
  const w = window.open(linkDownloadCsv.value, '_blank');
  w?.focus();
}

const downloadPDF = function() {
  const w = window.open(linkDownloadPDF.value, '_blank');
  w?.focus();
}

const downloadPDFLayout = function() {
  const w = window.open(linkDownloadPDFLayout.value, '_blank');
  w?.focus();
}

const doNew = function() {
  Swal.fire({
    title: i18n.t('book.titleNew'),
    input: 'number',
    inputLabel: i18n.t('book.quantity'),
    inputValue: 1,
    showCancelButton: true,
    cancelButtonText: i18n.t('form.cancel'),
    confirmButtonText: i18n.t('form.ok'),
    inputValidator: (value) => {
      try {
        const quantity = parseInt(value);
        if (quantity <= 0) {
          return i18n.t('book.quantityMustBeBetween1And50');
        } else if (quantity > 50) {
          return i18n.t('book.quantityMustBeBetween1And50');
        }
      } catch (error) {
        return i18n.t('error.invalidValue');
      }
      return null;
    }
  })
  .then(result => {
    if (result.isConfirmed && result.value) {
      const quantity = parseInt(result.value);
      createBooks(quantity);
    }
  })
}

const statusStyle = function(type: BookStatusEnum) {
  switch (type) {
    case BookStatusEnum.Pending:
      return " background-color: var(--va-danger)";
    case BookStatusEnum.Used:
      return "background-color: var(--va-success)";
    case BookStatusEnum.InCampaign:
      return "background-color: var(--va-warning); color: #000";
    case BookStatusEnum.Dispatched:
      return "background-color: var(--va-info)";
    case BookStatusEnum.Available:
      return "background-color: var(--va-vue-green); color: #000";
    case BookStatusEnum.InTheStore:
      return "background-color: var(--va-theme-violet)";
    default:
      return "";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_navbar_item = _resolveComponent("va-navbar-item")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_VField = _resolveComponent("VField")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_collapse = _resolveComponent("va-collapse")!
  const _component_va_accordion = _resolveComponent("va-accordion")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_data_table = _resolveComponent("va-data-table")!
  const _component_base_list = _resolveComponent("base-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_base_list, {
        page: _unref(page),
        "page-count": pageCount.value,
        "current-route": _unref(ROUTE_NAMES).books,
        "page-loaded": _unref(pageLoaded),
        "show-delete": false,
        "has-filter": true,
        onPageChanged: onPageChanged,
        onDoNew: doNew
      }, {
        navbarItems: _withCtx(() => [
          _createVNode(_component_va_navbar_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_va_button, {
                color: "background",
                onClick: openScanner
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('book.openScanner')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_va_navbar_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_va_button, {
                color: "background",
                disabled: !linkDownloadPDFLayout.value,
                onClick: downloadPDFLayout
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('book.downloadLayoutPDF')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_va_navbar_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_va_button, {
                color: "background",
                disabled: !linkDownloadPDF.value,
                onClick: downloadPDF
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('book.downloadPDF')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_va_navbar_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_va_button, {
                color: "background",
                disabled: !linkDownloadCsv.value,
                onClick: downloadCsv
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('book.downloadCSV')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_va_accordion, { style: {"width":"calc(100% - 20px)"} }, {
              default: _withCtx(() => [
                _createVNode(_component_va_collapse, {
                  header: _ctx.$t('list.filters')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_card_content, { style: {"background-color":"var(--va-collapse-header-content-background-color)"} }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              (hasAccountPermission.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                      _hoisted_7,
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(filter).data.and.account = $event)),
                                        name: "account"
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accounts).data, (op) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: op.id,
                                            value: op.id
                                          }, _toDisplayString(op.name), 9, _hoisted_8))
                                        }), 128))
                                      ], 512), [
                                        [_vModelSelect, _unref(filter).data.and.account]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (hasAgentPermission.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                      _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('agent.title')), 1),
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(filter).data.and.agent = $event)),
                                        name: "agent"
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(agents).data, (op) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: op.id,
                                            value: op.id
                                          }, _toDisplayString(op.name), 9, _hoisted_12))
                                        }), 128))
                                      ], 512), [
                                        [_vModelSelect, _unref(filter).data.and.agent]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (hasCampaignPermission.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('campaign.title')), 1),
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(filter).data.and.campaign = $event)),
                                        name: "campaign"
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(campaigns).data, (op) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: op.id,
                                            value: op.id
                                          }, _toDisplayString(op.name), 9, _hoisted_16))
                                        }), 128))
                                      ], 512), [
                                        [_vModelSelect, _unref(filter).data.and.campaign]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('book.status')), 1),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(filter).data.and.status = $event)),
                                    name: "status"
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookStatus).data, (op) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: op.value,
                                        value: op.value
                                      }, _toDisplayString(op.text), 9, _hoisted_20))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _unref(filter).data.and.status]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_VField, { name: "lote" }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_va_input, _mergeProps(field, {
                                      modelValue: _unref(filter).data.and.lote,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_unref(filter).data.and.lote = $event)),
                                      class: "mb-4",
                                      outline: "",
                                      type: "number",
                                      label: _ctx.$t('book.lote')
                                    }), null, 16, ["modelValue", "label"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_22, [
                                _createVNode(_component_VField, { name: "sequential" }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_va_input, _mergeProps(field, {
                                      modelValue: _unref(filter).data.and.sequential.gte,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_unref(filter).data.and.sequential.gte = $event)),
                                      class: "mb-4",
                                      outline: "",
                                      type: "number",
                                      label: _ctx.$t('book.initialSequential')
                                    }), null, 16, ["modelValue", "label"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_VField, { name: "sequential" }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_va_input, _mergeProps(field, {
                                      modelValue: _unref(filter).data.and.sequential.lte,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_unref(filter).data.and.sequential.lte = $event)),
                                      class: "mb-4",
                                      outline: "",
                                      type: "number",
                                      label: _ctx.$t('book.finalSequential')
                                    }), null, 16, ["modelValue", "label"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_va_button, {
                                  color: "info",
                                  onClick: executeFilter
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('list.executeFilter')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_va_button, {
                                  class: "ml-3",
                                  color: "warning",
                                  onClick: cleanFilter
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('list.cleanFilter')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_va_data_table, {
            items: _unref(books).data,
            columns: _unref(headers).data,
            "sticky-header": "",
            loading: loadingBooks.value,
            "no-data-html": "Sem resultados",
            style: _normalizeStyle({
            '--va-data-table-scroll-table-color': 'var(--va-divider)',
          })
          }, {
            "cell(status)": _withCtx(({ rowData }) => [
              _createVNode(_component_va_chip, {
                color: "info",
                size: "small",
                style: _normalizeStyle(statusStyle(rowData.status))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`enums.${rowData.status}`)), 1)
                ]),
                _: 2
              }, 1032, ["style"])
            ]),
            _: 1
          }, 8, ["items", "columns", "loading", "style"])
        ]),
        _: 1
      }, 8, ["page", "page-count", "current-route", "page-loaded"])
    ])
  ]))
}
}

})